
import FlashSlash from "../../../assets/outline/FlashSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FlashSlashIcon({ className, dataTestid = "FlashSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FlashSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
